import React from "react";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

const HomeModalContent = ({ content, onClose }) => {
  const navigate = useNavigate();
  return (
    <ContentWrapper>
      <ContentText>{content}</ContentText>
      <ButtonWrapper>
        <CloseButton onClick={onClose}>닫기</CloseButton>
        <CertButton
          onClick={() => {
            onClose();
            navigate("/signup");
          }}
        >
          사업자 인증하기
        </CertButton>
      </ButtonWrapper>
    </ContentWrapper>
  );
};

const ContentWrapper = styled.div`
  padding: 28px 16px;
  text-align: center;
  width: 240px;
`;

const ContentText = styled.p`
  font-size: 0.875rem;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
`;

const commonButtonStyle = css`
  width: 120px;
  padding: 10px 0;
  font-size: 0.875rem;
  border-radius: 4px;
  border: none;
  font-weight: bold;
  cursor: pointer;
`;
const CloseButton = styled.button`
  ${commonButtonStyle}
  background-color: #F1F3F5;
  color: #878e95;
`;
const CertButton = styled.button`
  ${commonButtonStyle}
  background-color: #FF7A00;
  color: #ffffff;
`;

export default HomeModalContent;
